module.exports = __webpack_public_path__ + "images/breadcrumb-arrow-white.101538b6ed.svg";